module.exports = __webpack_public_path__ + "static/media/animation_website_design.b265e0ef.gif";